import { StorageTypes, ValidStorageTypes } from '../models/util.model';
import { injectable } from 'tsyringe';

@injectable()
export class BpStorage {
  static storageAvailable(type: ValidStorageTypes) {
    const storage = window[type];

    try {
      const x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return (
        e instanceof DOMException &&
        // everything except Firefox
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage.length !== 0
      );
    }
  }

  availableStorage: { [K in ValidStorageTypes]: boolean } = {
    localStorage: false,
    sessionStorage: false
  };

  constructor() {
    let k: ValidStorageTypes;
    for (k in this.availableStorage) {
      if (this.availableStorage.hasOwnProperty(k)) {
        this.availableStorage[k] = BpStorage.storageAvailable(k);
      }
    }
  }

  getStorage(type: ValidStorageTypes): Storage {
    if (this.availableStorage[type]) {
      return window[type];
    }
    return null;
  }

  setItem(type: StorageTypes, key: string, value: string): boolean {
    const storage = this.getStorage(type);
    if (storage) {
      try {
        storage.setItem(key, value);
        return true;
      } catch (e) {
        return (
          e instanceof DOMException &&
          // everything except Firefox
          (e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
          // acknowledge QuotaExceededError only if there's something already stored
          storage.length !== 0
        );
      }
    }
    return false;
  }

  getItem(type: StorageTypes, key: string): string | null {
    const storage = this.getStorage(type);
    if (storage) {
      try {
        return storage.getItem(key);
      } catch (e) {
        if (
          e instanceof DOMException &&
          // everything except Firefox
          (e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
          // acknowledge QuotaExceededError only if there's something already stored
          storage.length !== 0
        ) {
          return null;
        }
      }
    }
    return null;
  }

  removeItem(type: ValidStorageTypes, key: string): boolean {
    const storage = this.getStorage(type);
    if (storage) {
      try {
        storage.removeItem(key);
        return true;
      } catch (e) {
        return (
          e instanceof DOMException &&
          // everything except Firefox
          (e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
          // acknowledge QuotaExceededError only if there's something already stored
          storage.length !== 0
        );
      }
    }
    return false;
  }
}
